import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSolidityComponent } from './simple-icons-solidity.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSolidityComponent ],
    exports:      [ SimpleIconsSolidityComponent ],
    bootstrap:    []
})
export class SimpleIconsSolidityModule {}
